<template>
  <div class="custom-ui-group-wrapper">
    <div class="custom-ui-group-mobile" v-if="isMobile">
      <div class="group-dropdown" @click="display = !display" v-text="name" />
      <div class="group-dropdown-content" v-if="display" :class="classes" v-click-outside="close">
        <div class="slot-wrapper">
          <slot />
        </div>
      </div>
    </div>
    <div class="custom-ui-group-web" v-else>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, onUnmounted, provide, ref } from 'vue'

  const { name, position = 'left' } = defineProps<{
    name: string
    position?: 'left' | 'right'
  }>()

  const isMobile = ref<boolean>(false)
  const display = ref<boolean>(false)

  onMounted(() => {
    updateViewport()
    window.addEventListener('resize', updateViewport)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateViewport)
  })

  const close = () => {
    display.value = false
  }

  const classes = computed(() => {
    return [`position-${position}`]
  })

  const updateViewport = () => {
    isMobile.value = window.innerWidth <= 991.99
  }

  provide('isMobile', isMobile)
</script>

<style scoped lang="scss">
  .custom-ui-group-wrapper {
    position: relative;

    .custom-ui-group-web {
      @include flexible();
      gap: 0.5rem;
    }

    .custom-ui-group-mobile {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .group-dropdown {
        width: 100%;
        height: 100%;
        background-color: $brandColor;
        border-radius: 5px;
        cursor: pointer;
        padding: 0.5em 1em;
        color: #fff;
        text-align: center;
        font-size: 0.825rem;
        font-weight: 600;
      }

      .group-dropdown-content {
        position: absolute;
        top: 100%;
        width: auto;
        background-color: #fbfbfb;
        border-radius: 5px;
        padding: 1em;
        z-index: 999;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        .slot-wrapper {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }
        &.position-left {
          left: 0;
        }
        &.position-right {
          right: 0;
        }
      }
    }
  }
</style>
